import qs from 'qs';
import axios from 'axios';

const url = process.env.VUE_APP_API_BASE_URL;

function pending(params = {}) {
    return axios.get(`${url}/notifications/guidances`, {
        params: {
            page: params.page || 1,
            per_page: params.per_page || 10
        },
        paramsSerializer: params =>
            qs.stringify(params, { encode: false }),

        headers: {
            Accept: 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json'
        }
    }).then(response => {
        return {
            items: response.data.items || [],
            meta: response.data.meta || {
                total: 0,
                current_page: 1,
                last_page: 1,
                per_page: 10
            }
        };
    });
}

function count() {
    return axios.get(`${url}/notifications/guidances/count`, {
        headers: {
            Accept: 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json'
        }
    }).then(response => ({
        count: response.data.count || 0
    }));
}

export default {
    pending,
    count
};
